export default __webpack_public_path__ + "static/media/otto.6612bcda.svg";